<div class="product_container card mb-3" style="max-width: 540px;">
  <div class="ribbon">
    <span
      [ngClass]="{'green': product.status === 'active', 'blue' : product.status === 'finished', 'red': product.status === 'cancelled'}" translate>products.{{product.status}}</span>
  </div>
  <div style="position: absolute; right: 0;" class="dropdown d-flex justify-content-end">
    <i class='bx bx-dots-vertical-rounded' style="font-size: 1.5rem; padding: 5px; cursor: pointer;"
      id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
      <li *ngIf="['root', 'user'].includes(currentUser.role.name)"><button class="dropdown-item" (click)="onDeleteModal()" translate>products.deleteProduct<i class="fa fa-trash ms-2"></i></button></li>
      <li><button class="dropdown-item" (click)="onChangeStatusModal(product, false)"
          [disabled]="product.status === 'cancelled' ? 'disabled' : null" translate>products.cancelProduct<i class="fa fa-close ms-2"></i></button></li>
      <li *ngIf="this.currentUser.role.name !== 'worker'"><button class="dropdown-item"
          (click)="onChangeStatusModal(product, true)"
          [disabled]="product.status !== 'finished' ? 'disabled' : null" translate>products.openProduct<i class='bx bxs-lock-open ms-2'></i></button></li>
      <li *ngIf="this.currentUser.role.name !== 'worker'"><button class="dropdown-item"
          (click)="openModalLogActivity(product)" translate>filials.filial.activityLog</button></li>
      <li *ngIf="this.currentUser.role.name === 'root'"><button class="dropdown-item"
        (click)="getDetail(product)" translate>filials.details</button></li>
    </ul>
  </div>
  <div class="row g-0" (click)="seeProduct(product)">
    <div style="max-height: 207px; overflow: hidden;" class="col-md-4 d-flex justify-content-center align-items-center">
      <img class="w-100" *ngIf="product.previewImage" [src]="product.previewImage.path" alt="" />
      <span class="no_image" *ngIf="!product.previewImage"><i class='bx bx-camera-off'></i></span>
    </div>

    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">{{product.title}}</h5>
        <p class="card-text">{{product.description ? product.description : '/'}}</p>
        <div *ngIf="product.kilometers" class="my-1 d-flex align-items-center">
          <i class='bx bx-tachometer me-2'></i>
          <p class="m-0 small" translate [translateParams]="{value: product?.kilometers}">products.mileage</p>
        </div>
        <div class="my-2">
          <p class="m-0 small" translate
            [translateParams]="{latitude: product.location.latitude ? product.location.latitude : '/'}">products.latitude</p>
          <p class="m-0 small" translate
            [translateParams]="{longitude: product.location.longitude ? product.location.longitude : '/'}">products.longitude</p>
        </div>
        <p class="card-text">
          <i class='bx bxs-calendar me-2'></i>
          <small>{{product.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</small>
        </p>
      </div>
    </div>
  </div>
</div>

<app-modal (close)="toggleDeleteProduct = !toggleDeleteProduct" *ngIf="toggleDeleteProduct">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate
        [translateParams]="{name: product.title}">global.deleteInfo</h4>
    </div>
    <div class="modal-body">
      <button class="custom_button" (click)="deleteProduct(product)" translate>global.yes</button>
      <button class="custom_button" (click)="toggleDeleteProduct = false;" translate>global.no</button>
    </div>
  </div>
</app-modal>

<app-activity-log #dialogActivityLog [activeLogList]="activeLogList" ></app-activity-log>

<app-modal (close)="toggleDetails = !toggleDetails" *ngIf="toggleDetails">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>Product: {{product?.title}}</h4>
    </div>
    <div class="modal-body">
      <p style="font-size: 1rem; font-weight: inherit;">Inventar: {{product.inventar?.name}}</p>
      <p style="font-size: 1rem; font-weight: inherit;">Filial: {{product.inventar?.filial?.name}}</p>
    </div>
  </div>
</app-modal>